import { render } from "./RemoteView.vue?vue&type=template&id=de535d92&scoped=true"
import script from "./RemoteView.vue?vue&type=script&lang=js"
export * from "./RemoteView.vue?vue&type=script&lang=js"

import "./RemoteView.vue?vue&type=style&index=0&id=de535d92&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de535d92"]])

export default __exports__